import React, { Component } from 'react';
import CargomaticInput from 'components/v2/input';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';

class DefaultLocationForm extends Component {
  constructor(props) {
    super(props);
    const details = props.details || {};
    this.state = {
      _id: details._id,
      name: details.name || '',
      address: details.address || '',
    };
  }

  componentDidUpdate(prevProps) {
    const prevDetails = prevProps.details || {};
    const currDetails = this.props.details || {};
    if (prevDetails._id !== currDetails._id) {
      this.setState({
        _id: currDetails._id,
        name: currDetails.name || '',
        address: currDetails.address || '',
      });
    }
  }

  onSave = () => {
    const { _id, name, address } = this.state;
    this.props.onSave(_id ? { _id, name, address } : { name, address });
  };

  handleFieldChange = (field) => (value) => {
    this.setState({ [field]: value });
  };

  handleAddressChange = (item) => {
    const { address } = item;
    this.setState({ address });
  };

  render() {
    const { address, name } = this.state;
    const { t } = this.props;
    return (
      <div>
        <h4 className="mt-0 mb-4 text-grey-darker">{this.props.title}</h4>
        <div className="userDefaultOrigin grid sm:grid-cols-1 sm:gap-y-6 sm:gap-x-4">
          <CargomaticInput
            className="sm:col-span-full"
            label={t('NAME')}
            info={t('NAME_OF_LOCATION')}
            value={name}
            onChange={this.handleFieldChange('name')}
            maxLength={50}
          />
          <CargomaticInput
            className="sm:col-span-full"
            type="location"
            label={titleize(t('ADDRESS'))}
            info={t('ADDRESS_FOR_LOCATION')}
            value={address}
            onSelect={this.handleAddressChange}
          />
          <div className="form-actions">
            <button
              type="button"
              className="button button-green"
              onClick={this.onSave}
            >
              {titleize(t('SAVE'))}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(DefaultLocationForm);
